// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__27499","header":"Messages_header__3AGJq"};